import script from "./FindMatch.vue?vue&type=script&setup=true&lang=js"
export * from "./FindMatch.vue?vue&type=script&setup=true&lang=js"

import "./FindMatch.vue?vue&type=style&index=0&id=5d009bca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d009bca"]])

export default __exports__